/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

export enum TourViewMode {
  TourList = 'tourList',
  ReturnList = 'returnList',
  MonthOverview = 'monthOverview'
}
